import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import ClasificacionesQuejaProfecoTable from './_ClasificacionesQuejaProfeco.js';
import EditClasificacionQuejaProfeco from './_EditClasificacionQuejaProfeco.js';

const URI = ApiEndpoint + 'administration/';
const ClasificacionesQuejaProfeco = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [clasificacionesQuejaProfeco, setClasificacionesQuejaProfeco] =
    useState(false);

  const [idClasificacionQuejaProfecoEdit, setIdClasificacionQuejaProfecoEdit] =
    useState(false);
  const handleClose = () => {
    setOpenModal(false);
    getClasificacionesQuejaProfeco();
  };

  const getClasificacionesQuejaProfeco = async () => {
    console.log('entre a getClasificacionesQuejawm');
    setClasificacionesQuejaProfeco(null);

    httpClient('GET', URI + 'clasificationsprofeco/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setClasificacionesQuejaProfeco(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    getClasificacionesQuejaProfeco();
  }, []);

  return (
    <>
      {clasificacionesQuejaProfeco && (
        <ClasificacionesQuejaProfecoTable
          clasificacionesQuejaProfeco={clasificacionesQuejaProfeco}
          setIdClasificacionesQuejaToEdit={setIdClasificacionQuejaProfecoEdit}
          setOpenModal={setOpenModal}
        ></ClasificacionesQuejaProfecoTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idClasificacionQuejaProfecoEdit > 0 ? 'Editar' : 'Agregar') +
            ' Clasificacion'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditClasificacionQuejaProfeco
            idClasificacionQueja={idClasificacionQuejaProfecoEdit}
            closeModal={handleClose}
          ></EditClasificacionQuejaProfeco>
        </MyModal>
      )}
    </>
  );
};

export default ClasificacionesQuejaProfeco;
